export interface SnackbarPayload {
  color: string;
  message: string;
  icon: string;
}
